function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function parseCommandResult<T>(content: unknown): T {
  if (!isRecord(content) || !isRecord(content['data'])) {
    throw new Error('Command returned an invalid response');
  }
  const attributes = content['data']['attributes'];
  if (!isRecord(attributes) || !('result' in attributes)) {
    throw new Error('Command did not return a result');
  }
  return attributes['result'] as T;
}
